module.exports = __webpack_public_path__ + "img/interviewaccepted.ab13fe8f.svg";